module.exports = __webpack_public_path__ + "img/1517718275.de9998c0.jpg";